// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
// import Snotify from 'vue-snotify'; // 1. Import Snotify
import QuillEditor from 'vue-quill-editor'
import infiniteScroll from 'vue-infinite-scroll'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'swiper/dist/css/swiper.css'
import MetaInfo from 'vue-meta-info'
import Promise from 'es6-promise'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueClipboard from 'vue-clipboard2'
import {handleDate} from '@/utils/dateFormat'


Promise.polyfill();

Vue.config.productionTip = false;

import 'lib-flexible'
import {getStore} from "./utils/storage";

import Dialog from 'v-dialogs'
Vue.use(Dialog, {
  // global config options...
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
router.beforeEach((to, from, next) => {
  let isLogin = getStore('token'); // 默认没有登录
  let matched = to.matched.some((item) => {
    return item.path === '/mine';
  });
  if (!isLogin && matched) {
    next('/');
  } else {
    next();
  }
});


const snotifyOptions = {
  toast: {
    position: SnotifyPosition.centerCenter,
    // config:{
    //   position: SnotifyPosition.centerCenter,
    // }
  }
  // animation: animationDefaults[SnotifyPosition.centerCenter]

}

Vue.use(Snotify,snotifyOptions)
// Vue.use(Snotify)
Vue.use(QuillEditor); //富文本
Vue.use(infiniteScroll); //触底加载
Vue.use(VueLazyload,{
  preLoad: 1,
  error: './static/img/loading_default.png',
  loading: './static/img/loading_default.png',
  attempt: 1
}); //图片懒加载
Vue.use(MetaInfo); //动态加载meta
Vue.use(VueAwesomeSwiper); //swiper
Vue.use(VueClipboard);  //剪切板

Vue.filter('dateFormatFilter',function(msg){
  return handleDate(msg);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js